export default __webpack_public_path__ + "media/color/ae-eb074fd0.svg";